// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1sHts","upload":"Small_upload__2yXEt","imageWrap":"Small_imageWrap__o9NFd","removeBtn":"Small_removeBtn__3Gwh7"};